import React, { useState, useEffect } from 'react'
import { Table, Input, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import {
  GetFeeApprovedList,
  getRoomAllocationList,
} from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'

const RoomAllocationList = () => {
  const storedBranchId = sessionStorage.getItem('branch_id')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchRoomApprovedList()
  }, [])

  const fetchRoomApprovedList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${getRoomAllocationList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        wh_mobile: item.wh_mobile || '-',
        class_name: item.roombooking.class.class_name || '-',
        room: item.roombooking.room.room_no || '-',
        bed: item.roombooking.bed.bed_no || '-',

        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (item.full_name ?? '').toLowerCase().includes(search)
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: "What's App No.", dataIndex: 'wh_mobile' },
    { title: 'Building', dataIndex: 'class_name' },
    { title: 'Room', dataIndex: 'room' },
    { title: 'Bed', dataIndex: 'bed' },
  ]

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => {
      const student = { ...item.full_data }

      // Flatten nested objects
      student.admin = student.admin?.username || ''
      student.documents = JSON.stringify(student.documents || {})

      return student
    })

    const worksheet = XLSX.utils.json_to_sheet(excelData)
    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Room Allocation')

    XLSX.writeFile(workbook, 'Room_Allocation_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Room Allocation List</h2>
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '15px',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>
            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
            className="shadow border rounded"
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  )
}

export default RoomAllocationList
